import _ from 'lodash';

const NonAlphanumericSeparator = /[^\w\d]+/g;
const WhitespaceSeparator = /\s+/g;

export function catsearch(
  string,
  query,
  { caseSensitive = false, ignoreSpecialSymbols = false } = {},
) {
  let tempString = string;
  let tempQuery = query;
  if (!caseSensitive) {
    tempString = !_.isObject(tempString) ? tempString.toLowerCase() : '';
    tempQuery = !_.isObject(tempString) ? tempQuery.toLowerCase() : '';
  }

  const separatorRegex = ignoreSpecialSymbols
    ? NonAlphanumericSeparator
    : WhitespaceSeparator;

  const queryParts = tempQuery.trim().replace(separatorRegex, ' ').split(' ');

  const stringParts = tempString.trim().replace(separatorRegex, ' ').split(' ');

  return queryParts.every(qp =>
    stringParts.some(sp => {
      if (sp.includes(qp)) {
        const index = stringParts.indexOf(sp);
        if (index > -1) {
          stringParts.splice(index, 1);
        }
        return true;
      }
      return false;
    }),
  );
}
